import React from 'react';
import { useNavigate } from 'react-router-dom';

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className="section-gap py-12">
      <button
        onClick={() => navigate(-1)}
        className="flex items-center gap-2 text-muted hover:text-text transition-colors text-sm"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
        </svg>
        Back
      </button>

      <div className="space-y-8 max-w-3xl">
        <div>
          <h1 className="font-display text-5xl tracking-display text-text uppercase">Terms of Service</h1>
          <p className="font-serif-display italic text-muted text-lg mt-2">Effective date: March 1, 2026</p>
        </div>

        <section className="space-y-3">
          <h2 className="font-display text-xl tracking-display-sm text-text uppercase">1. Acceptance of Terms</h2>
          <p className="text-muted leading-relaxed">
            By accessing or using the BunyadKar platform ("Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the Service. These terms apply to all users, including founders, mentors, and administrators.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="font-display text-xl tracking-display-sm text-text uppercase">2. Services Description</h2>
          <p className="text-muted leading-relaxed">
            BunyadKar is a virtual incubation platform that provides structured learning programs, one-on-one mentorship, resource libraries, progress tracking, and community tools to early-stage entrepreneurs. We reserve the right to modify, suspend, or discontinue any feature of the Service at any time.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="font-display text-xl tracking-display-sm text-text uppercase">3. User Accounts</h2>
          <p className="text-muted leading-relaxed">
            You must create an account to access the platform. You are responsible for maintaining the confidentiality of your credentials and for all activity that occurs under your account. You agree to provide accurate information during registration and to update it as necessary. Accounts are personal and may not be shared or transferred.
          </p>
          <p className="text-muted leading-relaxed">
            Mentor accounts are subject to admin review and approval before platform access is granted. We reserve the right to suspend or terminate accounts that violate these terms.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="font-display text-xl tracking-display-sm text-text uppercase">4. Intellectual Property</h2>
          <p className="text-muted leading-relaxed">
            All content provided by BunyadKar — including course materials, templates, guides, and platform design — is the property of BunyadKar and is protected by applicable intellectual property laws. You may not reproduce, distribute, or create derivative works without our express written permission.
          </p>
          <p className="text-muted leading-relaxed">
            Content you submit to the platform (such as pitch decks, startup profiles, and milestone updates) remains your property. By submitting content, you grant BunyadKar a limited, non-exclusive licence to use that content to operate and improve the Service.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="font-display text-xl tracking-display-sm text-text uppercase">5. Prohibited Uses</h2>
          <p className="text-muted leading-relaxed">You agree not to:</p>
          <ul className="text-muted leading-relaxed space-y-1 list-disc list-inside">
            <li>Use the platform for any unlawful purpose or in violation of any regulations</li>
            <li>Upload or transmit viruses, malware, or any other malicious code</li>
            <li>Attempt to gain unauthorised access to any part of the Service or its related systems</li>
            <li>Harass, abuse, or harm other users or BunyadKar staff</li>
            <li>Scrape, crawl, or systematically extract data from the platform</li>
            <li>Impersonate any person or entity, or misrepresent your affiliation</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="font-display text-xl tracking-display-sm text-text uppercase">6. Disclaimers</h2>
          <p className="text-muted leading-relaxed">
            The Service is provided "as is" and "as available" without warranties of any kind, either express or implied. BunyadKar does not warrant that the Service will be uninterrupted, error-free, or free of harmful components. Mentorship and programme content are provided for educational purposes and do not constitute professional legal, financial, or business advice.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="font-display text-xl tracking-display-sm text-text uppercase">7. Limitation of Liability</h2>
          <p className="text-muted leading-relaxed">
            To the fullest extent permitted by law, BunyadKar shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of, or inability to use, the Service. Our aggregate liability for any claim arising out of or relating to these terms shall not exceed the amount you paid us in the twelve months preceding the claim.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="font-display text-xl tracking-display-sm text-text uppercase">8. Changes to Terms</h2>
          <p className="text-muted leading-relaxed">
            We may update these Terms of Service from time to time. When we do, we will revise the effective date at the top of this page and notify users via the platform or email. Continued use of the Service after changes take effect constitutes your acceptance of the revised terms.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="font-display text-xl tracking-display-sm text-text uppercase">9. Contact</h2>
          <p className="text-muted leading-relaxed">
            If you have questions about these Terms of Service, please contact us at{' '}
            <a href="mailto:legal@founderslab.io" className="text-chart hover:text-chart/80">
              legal@founderslab.io
            </a>
            .
          </p>
        </section>
      </div>
    </div>
  );
};

export default Terms;
